import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import { BootstrapVueNext } from 'bootstrap-vue-next'
import PrimeVue from 'primevue/config';
import Material from "@primevue/themes/material";
// import Material from '@primevue/themes/material';

// Import Bootstrap and BootstrapVue CSS    
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import './assets/tailwind.css';
import { FontAwesomeIcon } from './plugins/font-awesome';

const app = createApp(App);

// Configure Vue global properties
app.config.globalProperties.apiUrl = 'https://api.abra.slox.cz/BazarCD';

// Register components and plugins
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(router);
app.use(store);
// app.use(BootstrapVueNext);
app.use(PrimeVue, { 
    theme: {
        preset: Material,
        options: {
            darkModeSelector: '.fake-dark-selector', // trying to also force a non-usage of the dark mode
        } 
    }
});
app.mount("#app");